import { render, staticRenderFns } from "./EnablePagesDialog.vue?vue&type=template&id=ec681664&scoped=true&"
import script from "./EnablePagesDialog.vue?vue&type=script&lang=js&"
export * from "./EnablePagesDialog.vue?vue&type=script&lang=js&"
import style0 from "./EnablePagesDialog.vue?vue&type=style&index=0&id=ec681664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec681664",
  null
  
)

export default component.exports